var _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoopMaxMin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87305 1C11.6689 1.00015 14.745 4.07621 14.7451 7.87012C14.7451 8.93952 14.5019 9.94999 14.0674 10.8506L13.8691 11.2305C13.4688 11.9431 13.4712 12.9044 14.0547 13.6035L14.1787 13.7402L19.5859 19.1445L19.1445 19.5859L13.7354 14.1787C13.0741 13.5177 12.1172 13.4491 11.374 13.7939L11.2285 13.8682C10.2372 14.4237 9.09346 14.7402 7.87305 14.7402C4.07703 14.7402 1 11.6642 1 7.87012C1.00013 4.07612 4.07711 1 7.87305 1Z",
    stroke: "#75848A",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#75848A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#75848A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 6,
    height: 2,
    rx: 1,
    transform: "rotate(-90 7 9)",
    fill: "#75848A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopMaxMin);
export default __webpack_public_path__ + "static/media/loopMaxMin.0a8fc62e12f3ae6946ac86ad2684f440.svg";
export { ForwardRef as ReactComponent };